'use client';

import React from 'react';

type ContextApi = {
  isBusinessCustomer: boolean;
};

const CustomerContext = React.createContext<ContextApi | null>(null);

export function CustomerContextProvider({
  children,
  isBusinessCustomer
}: {
  children: React.ReactNode;
  isBusinessCustomer: boolean;
}) {
  return (
    <CustomerContext.Provider
      value={{
        isBusinessCustomer
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
}

export const useCustomerContext = () => {
  const context = React.useContext(CustomerContext);

  if (!context) {
    throw new Error('useCustomerContext must be used within a CustomerContext.Provider');
  }

  return context;
};
